<template>
    <div class="container">
        <VehicleEntryFormWrapper ref="entryForm" :vehicle="vehicleEntry" :commodities="commodities"/>

        <div class="my-4">
            <button class="btn btn-primary w-100 py-3 fw-bold fs-5 text-white" @click="submitForm">{{ $t("utils.saveChanges") }}</button>
        </div>
    </div>
</template>

<script>
    import VehicleEntryFormWrapper from '@/components/VehicleEntryFormWrapper.vue';

    export default {
        components: {
            VehicleEntryFormWrapper,
        },
        data() {
            return {
                vehicleEntry: {},
                commodities: [],
            };
        },
        created() {
            this.getVehicleEntry();
            this.getCommodity();
        },
        methods: {
            getVehicleEntry() {
                this.$store.getters.api.get(`/${this.$route.params.slug}/vehicle-entries/${this.$route.params.id}`)
                .then(response => {
                    this.vehicleEntry = response.data;
                })
                .catch(error => {
                    console.error("Error loading vehicle entry", error);
                });
            },
            getCommodity() {
                this.$store.getters.api.get(`/${this.$route.params.slug}/vehicle-entries/${this.$route.params.id}/commodities`)
                .then(response => {
                    this.commodities = response.data;
                })
                .catch(error => {
                    console.error("Error loading commodities", error);
                });
            },
            submitForm() {
                const result = this.$refs.entryForm.collectFormData();
                if (!result) return;

                const { vehicle, commodities } = result

                const formData = {
                    ...vehicle,
                    commodities,
                }

                this.$store.getters.api.patch(`/${this.$route.params.slug}/vehicle-entries/${this.$route.params.id}/edit`, formData)
                .then((response) => {
                    this.$router.push({
                        name: "vehicleEntryDetailView",
                        params: {
                            slug: this.$route.params.slug,
                            id: response.data.id
                        }
                    });
                })
                .catch(error => {
                    console.error("Error editing vehicle entry", error);
                });
            },
        }
    }
</script>